/**
 * LOS MENÚS DE JESÚS Y DE LOS ENTRENADORES, APARTE (Jesús, WhatsApp 28-09 22:14): «además de
 * los menús que están hechos por otros usuarios, utilizar unos menús que sean hechos por
 * entrenadores y ponerlos como aparte, que se puedan seleccionar también».
 *
 * En «Elige tu menú» es un chip más, «De entrenadores», al lado de «Recetas». Con él puesto se
 * piden al servidor solo los menús del equipo (`solo_entrenadores`); las recetas del
 * recetario tienen su propio chip. Quién es del equipo lo decide el servidor
 * (backend/core/menus_de_entrenadores.py) y lo dice en `de_entrenador`.
 */
export const CHIP_ENTRENADORES = 'entrenadores';

// La cuenta de Jesús: sus menús de la biblioteca llevan su nombre corto («Jesús G.»).
const NOMBRE_DE_JESUS = /^jes[uú]s g\b/i;

// Lo que dice la etiqueta de procedencia de una tarjeta de menú. SIN AUTOR, SALVO JESÚS
// (31-10): decía «De Daniel D.» y «Entrenador · Jose L.».
export const etiquetaAutor = (menu) => {
    if (menu?.de_entrenador) {
        return menu.de_jesus || NOMBRE_DE_JESUS.test((menu.autor_nombre || '').trim())
            ? 'De Jesús' : 'De un entrenador';
    }
    return 'De otros usuarios';
};

// Con el chip puesto, solo los del equipo (el servidor ya los filtra; esto es la red).
export const soloDeEntrenadores = (menus) => (menus || []).filter(m => m?.de_entrenador);
